import React, { Fragment } from 'react';
import { EventFractionalOrderReport } from '@/model/EventFractionalOrderReport';
import { Col, Row } from 'reactstrap';
import { updateMask } from '@/helpers/masks/cpf';
import dayjs from 'dayjs';
import { CustomTable } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import PaymentType from '@/model/PaymentType';
import PaymentStatus from '@/model/PaymentStatus';

interface StateProps {
  order?: EventFractionalOrderReport;
}

export const DetailFractionalSaleContent: React.FC<StateProps> = ({ order }): JSX.Element => {
  const toPaymentType = (paymentType: PaymentType): string => {
    let value = '';
    if (paymentType === PaymentType.CREDIT_CARD || paymentType === PaymentType.TWO_CREDIT_CARDS) {
      value = 'Crédito';
    } else if (paymentType === PaymentType.DEBIT_CARD) {
      value = 'Débito';
    } else if (paymentType === PaymentType.PIX) {
      value = 'PIX';
    } else if (paymentType === PaymentType.BANK_SLIP) {
      value = 'Boleto';
    } else if (paymentType === PaymentType.MONEY) {
      value = 'Dinheiro';
    } else if (paymentType === PaymentType.CHECK) {
      value = 'Cheque';
    }
    return value;
  };
  const toPaymentStatus = (paymentStatus: PaymentStatus): string => {
    let value = '';
    if (paymentStatus === PaymentStatus.APPROVED) {
      value = 'Aprovado';
    } else if (paymentStatus === PaymentStatus.DISAPPROVED) {
      value = 'Reprovado';
    } else if (paymentStatus === PaymentStatus.AWAITING_PAYMENT) {
      value = 'Aguardando Pagamento';
    } else if (paymentStatus === PaymentStatus.CANCELED) {
      value = 'Cancelado';
    } else if (paymentStatus === PaymentStatus.CANCELLATION_ANALYSIS) {
      value = 'Cancelado Solicitado';
    }
    return value;
  };
  return (
    <Fragment>
      <>
        {order && (
          <div>
            <Row>
              <Col md={12}>
                <label className={'input-label m-0'}>Link de pagamento site</label>
              </Col>
            </Row>
            <Row>
              <Col md={12}>{order.link}</Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
              <Col md={12}>
                <label className={'input-label m-0'}>QrCode POS</label>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <img src={order.qrCode} />
              </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
              <Col md={12}>
                <label className={'input-label m-0'}>Código do pedido</label>
              </Col>
            </Row>
            <Row>
              <Col md={12}>{order.orderId}</Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
              <Col md={12}>
                <label className={'input-label m-0'}>Ponto de venda</label>
              </Col>
            </Row>
            <Row>
              <Col md={12}>{order.pdv}</Col>
            </Row>
            {order.clientName && order.clientCPF && (
              <Fragment>
                <Row style={{ marginTop: '30px' }}>
                  <Col md={12}>
                    <label className={'input-label m-0'}>Nome do comprador</label>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>{order.clientName}</Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                  <Col md={12}>
                    <label className={'input-label m-0'}>CPF do comprador</label>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>{updateMask(order.clientCPF)}</Col>
                </Row>
              </Fragment>
            )}

            <Row style={{ marginTop: '30px' }}>
              <Col md={12}>
                <label className={'input-label m-0'}>Data da compra</label>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {dayjs(order.orderDate).locale('pt-br').format('DD/MM/YYYY [às] HH:mm')}
              </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
              <Col md={12}>
                <label className={'input-label m-0'}>Camarote</label>
              </Col>
            </Row>
            <Row>
              <Col md={12}>{`${order.ticket} - ${order.label}`}</Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
              <Col md={12}>
                <label className={'input-label m-0'}>Ingressos</label>
              </Col>
            </Row>
            {order.payments && order.payments.length > 0 && (
              <Row>
                <Col md={12}>
                  <CustomTable
                    columns={[
                      {
                        name: 'Data',
                        selector: row => row.paymentDate,
                        width: '15%',
                      },
                      {
                        name: 'Valor',
                        selector: row => row.paymentValue,
                        width: '15%',
                      },
                      {
                        name: 'Forma Pag.',
                        selector: row => row.paymentType,
                        width: '15%',
                      },
                      {
                        name: 'Status',
                        selector: row => row.paymentStatus,
                        width: '25%',
                      },
                    ]}
                    data={order.payments.map(payment => ({
                      paymentDate: payment.paymentDate
                        ? dayjs(payment.paymentDate).locale('pt-br').format('DD/MM/YYYY [às] HH:mm')
                        : '----',
                      paymentValue:
                        payment.paymentValue && payment.paymentValue > 0
                          ? toCurrency(payment.paymentValue)
                          : '----',
                      paymentType: toPaymentType(payment.paymentType),
                      paymentStatus: toPaymentStatus(payment.paymentStatus),
                    }))}
                    numberRowsPerPage={order.payments.length}
                    progressPending={false}
                  />
                </Col>
              </Row>
            )}
          </div>
        )}
      </>
    </Fragment>
  );
};
